<template>
    <div class="KnowledgeBasePost">
		<div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
			<div class="d-flex flex-wrap align-items-center">
				<!-- <span v-for="tg in masTopicTags" :key="tg.id">
					<span v-if="ApiData.topicTag == tg.id"  class="badge badge-primary mr-2">{{tg.value}}</span>	
				</span> -->
				<span><span v-if="topicName && topicName!='' && topicName!=undefined" class="badge badge-primary mr-2">{{topicName}}</span></span>
				<h3 class="mb-1">{{ApiData.name}}</h3>
			</div>
			<div>
				<div class="bntGroup">
					<base-button type="primary" simple @click="backByHistory()" ><i class="tim-icons icon-double-left mr-2"></i>Назад</base-button>
					<button v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1" class="ml-3 btn btn-icon btn-simple btn-primary" @click="GoToEdit(ApiData.id)"><i class="tim-icons icon-pencil"></i></button>	
				</div>
			</div>
		</div>	

		<card>
			<div class="row">
				<div class="col-12 col-lg-8 mb-3">
					<template v-if="ApiData">
						<p v-html="ApiData.descr"/>
					</template>
				</div>
				<div class="col-12 col-lg-4 sticky-container">
					<div class="sticky-item">
						<div class="moreFAQ mb-3" v-if="FAQByTopic.length>0">
							<h6 class="zipal-error-text">Больше подсказок по данной теме</h6>	
							<ReCardKBPost v-for="faq in FAQByTopic" :objFAQ="faq" :key="faq.id"/>
						</div>
					</div>	
				</div>
			</div>
		</card>

	</div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
//import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';
import ReCardKBPost from 'src/our_components/knowledgebase/ReCardKBPost.vue';

export default {
	name: 'KnowledgeBasePost-page',
	components: {
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		ReCardKBPost,
	},
	props: {
		kb_group:{
			type: String,
			default: 'KB_MAIN',
		}
	},
	data() {
		return {
			ApiData: {},
			FAQByTopic: [],
			objGetParams:{},
			topicName:'',
			fullscreenLoading: false,
			bIsEdit: false,
		};
	},
	watch: {

	},
	computed: {

	},
	methods: {
		getApiData(){
			this.$GVO.ApiCall(`${this.$route.params.kb_group}.GET`,{flt: {id:this.$route.params.post_id} }) /**/
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data[0];
						this.getFAQByTopic(this.ApiData.topicTag);

						let themes_cat = `CAT_${this.$route.params.kb_group}_THEMES`;

						this.$GVO.LoadCatPromise(themes_cat)
						.then((objApi) => {
							if(objApi=== true){
								for (let i = 0; i < this.$GVO.cats[themes_cat].length; i++) {
									const element = this.$GVO.cats[themes_cat][i];
									if(element.act==1 && element.id==this.ApiData.topicTag){
										this.topicName = element.name;
									}
									
								}
							}
						})
						.catch(errorObjApi => {console.error(errorObjApi); });
					}
				}else{
					this.ApiData = {};
					// this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = {}; console.error(errorObjApi);});
		},
		getFAQByTopic(topicTag){
			this.$GVO.ApiCall(`${this.$route.params.kb_group}.GET`,{flt: {topicTag:topicTag, excludecurrent: this.$route.params.post_id} }) 
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.FAQByTopic = objApi.data;
						if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
						
					}
				}else{
					this.FAQByTopic = [];
					this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.FAQByTopic = []; this.masApi_total=0; console.error(errorObjApi);});

		},
		backByHistory(){
			this.$router.go(-1);
		},
		GoToEdit(id){
			this.$router.push({path: '/data/knowledgebase/posts/'+this.$route.params.kb_group+'/id/'+id+'/edit'});
		},
	},
	mounted() {
		this.getApiData();
	}
};
</script>
<style scoped>

.KnowledgeBasePost >>>  .sticky-container {position: relative;}
.KnowledgeBasePost >>>  .sticky-item {display: flex; flex-direction: column; position: sticky; top: 15px; z-index: 2; background: inherit;}
.KnowledgeBasePost >>> .moreFAQ {margin-bottom: 15px; border: 1px dashed #BA54F5; border-radius: 6px; padding: 10px; grid-gap: 10px;}


/* .KnowledgeBasePost >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);} */
.KnowledgeBasePost >>>  .el-table table {width: 100%!important;}
.KnowledgeBasePost >>>  .el-table .cell {word-break: break-word;}

.KnowledgeBasePost >>> .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.KnowledgeBasePost >>> .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: baseline;
	flex-wrap: wrap;
}
.KnowledgeBasePost >>> .form-options-group > div{
	margin-right: 5px;
}
.KnowledgeBasePost >>> .form-group {
	margin-bottom: 0px!important;
}
.KnowledgeBasePost >>> .cell {
	word-break: break-word!important;
	/* line-height: 10px; */
}
/* .KnowledgeBasePost >>> .el-table tr:hover {
    background: rgb(1, 176, 224, 0.33);
} */

.KnowledgeBasePost >>> .photoFAQ{
	max-width: 700px;
    height: auto;
    margin: 10px 0;
    width: 100%;
}
.KnowledgeBasePost p {max-width: 700px;}
.KnowledgeBasePost {
	display: flex;
	flex-direction: column;
	margin-bottom: 5px;
	/* max-width: 49%; */
}

@media (max-width: 576px){
		.filter-tag-row {padding: 0 15px;}
	}

</style>
